import { setCookie } from '../helper-function/coockie/setCookie';
import { getCookie } from '../helper-function/coockie/getCookie';
import { deleteCookie } from '../helper-function/coockie/deleteCookie';
import { initTabs } from '../components/initTabs';
import { initSliderReviews } from '../components/sliders/initSliderReviews';

window.addEventListener('DOMContentLoaded', function () {
    initTabs();
    initSliderReviews();

    // sticky block
    if (document.querySelector('.timer-block-sticky')) {
        const nav = document.querySelector('.timer-block-sticky');
        const navTop = nav.offsetTop;

        window.addEventListener('scroll', stickyNavigation);

        function stickyNavigation() {
            const headerHeight = document.querySelector('.header').clientHeight;

            if (window.scrollY >= navTop - headerHeight) {
                // nav offsetHeight = height of nav
                document.querySelector('.screen-block-container').style.marginBottom = nav.offsetHeight + 'px';
                document.querySelector('.timer-block-sticky').classList.add('fixed-nav');
            } else {
                document.querySelector('.screen-block-container').style.marginBottom = 0;
                document.querySelector('.timer-block-sticky').classList.remove('fixed-nav');
            }
        }

        window.addEventListener('scroll', stickyNavigation);
    }

    // timer init
    if (document.querySelector('.timer-block')) {
        if (document.querySelector('.my-timer--value')) {
            let myTimerMD = document.querySelector('.my-timer-m-d'),
                myTimerMO = document.querySelector('.my-timer-m-o'),
                myTimerSD = document.querySelector('.my-timer-s-d'),
                myTimerSO = document.querySelector('.my-timer-s-o'),
                myTimerHD = document.querySelector('.my-timer-h-d'),
                myTimerHO = document.querySelector('.my-timer-h-o'),
                footerTimerMD = document.querySelector('.footer-timer-m-d'),
                footerTimerMO = document.querySelector('.footer-timer-m-o'),
                footerTimerSD = document.querySelector('.footer-timer-s-d'),
                footerTimerSO = document.querySelector('.footer-timer-s-o'),
                footerTimerHD = document.querySelector('.footer-timer-h-d'),
                footerTimerHO = document.querySelector('.footer-timer-h-o');

            startTimerParent();

            function startTimerParent() {
                let totalTimer50off = Date.parse(new Date()) / 1000,
                    timer50off = totalTimer50off + 1200;

                if (
                    !getCookie('umobixTimerOff50') ||
                    getCookie('umobixTimerOff50') == null ||
                    getCookie('umobixTimerOff50') - totalTimer50off < 0
                ) {
                    setCookie('umobixTimerOff50', timer50off, timer50off);
                }

                let totalSeconds = getCookie('umobixTimerOff50') - totalTimer50off,
                    hMain = Math.trunc(totalSeconds / 3600) % 24,
                    mMain = Math.trunc(totalSeconds / 60) % 60,
                    sMain = Math.trunc(totalSeconds) % 60;

                outputSpanTimer(String(hMain), myTimerHO, myTimerHD);
                outputSpanTimer(String(mMain), myTimerMO, myTimerMD);
                outputSpanTimer(String(sMain), myTimerSO, myTimerSD);
                outputSpanTimer(String(hMain), footerTimerHO, footerTimerHD);
                outputSpanTimer(String(mMain), footerTimerMO, footerTimerMD);
                outputSpanTimer(String(sMain), footerTimerSO, footerTimerSD);

                function outputSpanTimer(textInto, currSpanT, currSpanO) {
                    currSpanT.innerHTML = '';
                    currSpanO.innerHTML = '';
                    if (!textInto[1]) {
                        if (!textInto) {
                            currSpanO.innerHTML = '0';
                            currSpanT.innerHTML = '0';
                        } else {
                            currSpanO.innerHTML = '0';
                            currSpanT.innerHTML = textInto[0];
                        }
                    } else {
                        currSpanT.innerHTML = textInto[1];
                        currSpanO.innerHTML = textInto[0];
                    }
                }

                if (!hMain && !mMain && !sMain) {
                    deleteCookie('umobixTimerOff50');
                    window.location.reload();
                    return;
                }

                setTimeout(startTimerParent, 1000);
            }
        }
    }
});
